
<div class="keeper" *ngIf="renderApp">
    <router-outlet *ngIf="!isIframe"></router-outlet>
</div>
<!-- <div class="version">
    <b>front: </b> {{version?.front}}
    <b>back: </b> {{version?.back}}
</div> -->
<p-toast position="bottom-right">
    <ng-template let-message pTemplate="message">
        <div>
            <h3>{{message.summary}}</h3>
            <p>{{message.detail}}</p>
        </div>
    </ng-template>
</p-toast>
<mapfre-auditlib-spinner></mapfre-auditlib-spinner>
<mapfre-auditlib-modal [(visible)]="visible">
    <div class="content-flow">
        <h2>{{modal?.title | translate}}</h2>
        <span class="me-2">{{modal?.question | translate}}</span>
        <small>{{modal?.subquestion | translate}}</small>
    </div>
    <div class="d-flex justify-content-end">
        <mapfre-auditlib-button class="me-3" (click)="sendResponse(true)">
            <span class="white" translate>FLOW.CONFIRM</span>
        </mapfre-auditlib-button>
        <mapfre-auditlib-button (click)="sendResponse(false)">
            <span class="white" translate>FLOW.CANCEL</span>
        </mapfre-auditlib-button>
    </div>
</mapfre-auditlib-modal>
<mapfre-auditlib-modal [(visible)]="showInactivityModal">
    <div class="content-flow content-flow-inactivity">
        <h2>{{ "INACTIVITY.PERIOD" | translate}}</h2>
        <span class="me-2">{{ "INACTIVITY.WARNING" | translate}}</span>
        <h3 class="text-center">{{timeLeft}}</h3>
    </div>
</mapfre-auditlib-modal>
<div class="mk mk-audit" *ngFor="let mka of mks['audit']" [style.color]="mka.c" [style.font-size.px]="mka.fs">AUDIT</div>
<div class="mk mk-map" *ngFor="let mka of mks['map']" [style.color]="mka.c" [style.font-size.px]="mka.fs">MAP</div>
<div class="mk mk-three" *ngFor="let mka of mks['three']" [style.color]="mka.c" [style.font-size.px]="mka.fs">3</div>